import {CommentsCategory, deleteCommentPath} from '@domain/comments'
import {ApiClient} from '@hconnect/apiclient'
import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient, useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {PLANNING_COMMENTS_WIDGET_NAMESPACE} from '../consts'

interface DeleteCommentParams {
  plantId: string
  commentsCategory: CommentsCategory
  commentCategoryInstanceId: string
  commentId: string
}

export const useDeleteCommentMutation = () => {
  const {t} = useTranslation(PLANNING_COMMENTS_WIDGET_NAMESPACE)
  const client = useQueryClient()

  return useMutation<void, AxiosError, DeleteCommentParams>({
    mutationFn: async ({plantId, commentsCategory, commentCategoryInstanceId, commentId}) => {
      const path = deleteCommentPath({
        plantId,
        commentsCategory,
        commentCategoryInstanceId,
        commentId
      })
      await ApiClient.axiosInstance.delete(path)
    },
    onSuccess: () => {
      spawnSuccessToast(t('comments.message.deleteSuccess'))
    },
    onSettled: () => {
      void client.invalidateQueries({
        queryKey: ['comments']
      })
    },
    onError: () => {
      spawnErrorToast(t('comments.message.failedToDeleteComment'))
    }
  })
}
